import { View } from 'react-native'
import Welcome from '@screens/customer/home/sections/Welcome'
import Frames from '@screens/customer/home/sections/Frames'
import Eyetest from '@screens/customer/home/sections/Eyetest'
import Page from '@shell/Page'
import TileSmall from '@ui/tiles/TileSmall'
import TileOption from '@ui/tiles/TileOption'
import TileBlur from '@ui/tiles/TileBlur'

const desc =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet purus sit amet nunc. Sed sit amet purus sit amet nunc.'

export default function DevTilesPage() {
  return (
    <Page stage="dev">
      <View className="gap-8 p-8">
        <Welcome />
        <View className="w-full flex-row gap-8">
          <Frames />
          <Eyetest />
        </View>
        <TileSmall title="TileSmall" desc={desc} />
        <TileOption title="TileOption" desc={desc} />
        <TileBlur variant="default" title="TileBlur Default" desc={desc} />
        <TileBlur variant="large" title="TileBlur Large" desc={desc} />
        <TileBlur variant="small" title="TileBlur Small" desc={desc} />
        <TileBlur variant="option" title="TileBlur Option" desc={desc} />
      </View>
    </Page>
  )
}
